module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-4x3-mobile@4x.dc604991.png";